import { render, staticRenderFns } from "./unauthorized.scene.vue?vue&type=template&id=1e79926f&scoped=true"
var script = {}
import style0 from "./unauthorized.scene.scss?vue&type=style&index=0&id=1e79926f&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e79926f",
  null
  
)

export default component.exports